import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { Location } from "../models/location";
import { applicationLogger } from "../logging/logger";
import { EventAggregator } from "aurelia-event-aggregator";
import { HubEvents } from "../events/hub-events";
import { MeasurementViewModel } from "../models/measurement-view-model";
import { updateLocation } from "../store/actions/location-actions";
import { dispatchify } from "aurelia-store";
import { AsEnumerable } from "linq-es2015/lib/linq";
import { Device } from "../models/device";
import { StatusColors } from "../pages/common/status-colors";
import { processMeasurement } from "../store/actions/measurement-actions";
import * as State from "../store/state";
import IState = State.IState;
import { GpsMap } from "../models/gps-map";
import { AssetLocationMeasurement } from "../models/asset-location-measurement";

export class LocationHub {
	private eventAggregator: EventAggregator;
	private connectionPromise?: Promise<void> = null;
	private static joinGroup: string = "joinLocationGroup";
	private static signalRUrl: string = "/sensor";

	

	location: Location;
	hubConnection: HubConnection = null;

	initialize(location: Location, eventAggregator: EventAggregator) {
		this.eventAggregator = eventAggregator;
		this.location = location;
		this.createHubConnection(location);
		this.start();
	}

	start() {
		if (this.hubConnection != null) {
			this.connectionPromise = this.hubConnection.start().then(() => {
				this.hubConnection.invoke(LocationHub.joinGroup, this.location.signalRGroup)
					.catch(err => applicationLogger.error(err));
			});
		}
	}

	dispose() {
		if (this.connectionPromise) {
			this.connectionPromise = null;
		}
		if (this.hubConnection) {
			this.hubConnection.stop();
			this.hubConnection = null;
		}
	}

	createHubConnection(location: Location) {
		this.hubConnection = new HubConnectionBuilder()
			.withUrl(LocationHub.signalRUrl)
			.withAutomaticReconnect()
			.build();

		this.hubConnection.on(HubEvents.measurementEvent,
			(measurementData: MeasurementViewModel) => {
				applicationLogger.debug(JSON.stringify(measurementData));
				dispatchify<IState, any[]>(processMeasurement)(measurementData);
			});

		this.hubConnection.on(HubEvents.gpsMappingEvent,
			(measurementData: GpsMap) => {
				applicationLogger.debug(JSON.stringify(measurementData));
				this.eventAggregator.publish(HubEvents.gpsMappingEvent, measurementData);
			});

		this.hubConnection.on(HubEvents.assetLocationMeasurementEvent,
			(measurementData: AssetLocationMeasurement) => {
				applicationLogger.debug(JSON.stringify(measurementData));
				this.eventAggregator.publish(HubEvents.assetLocationMeasurementEvent, measurementData);
			});

		this.hubConnection.onclose(error => {
			if (error) {
				applicationLogger.debug("LocationHub: Connection closed", error);

				// signal to the HubManager that this hub has lost it's connection to the server.
				this.eventAggregator.publish(HubEvents.signalRDisconnect, this.location.id);
			}
		});

		this.hubConnection.onreconnected(connectionId => {
			this.hubConnection.invoke(LocationHub.joinGroup, this.location.signalRGroup)
				.catch(err => applicationLogger.error(err));
		});
	}
}
